"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:field": "primusSection",
  "ui:layout": "section",
  "ui:title": "Avvik",
  "ui:label": false,
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData
    }) {
      return {
        description: formData && formData.title || "Uten tittel"
      };
    }

  },
  "ui:options": {
    "grid": true,
    "spacing": 2,
    "collapsible": true
  },
  "ui:fieldset": ["title", "observedAt", "description", "priorityId", "status"],
  "title": {
    "ui:title": "Tittel",
    "ui:help": "Kort beskrivelse av avviket"
  },
  "observedAt": {
    "ui:title": "Dato observert",
    "ui:help": "Når ble avviket observert?"
  },
  "priorityId": {
    "ui:title": "Prioritet",
    "ui:widget": "primusPriority"
  },
  "description": {
    "ui:title": "Detaljer",
    "ui:widget": "textarea",
    "ui:help": "Evt. utfyllende beskrivelse av avviket"
  },
  "observedAt": {
    "ui:title": "Dato observert",
    "ui:help": "Når ble avviket observert?"
  },
  "status": {
    "ui:title": "Status",
    "ui:widget": "radio",
    "ui:inline": true
  }
};
exports.default = _default;
module.exports = exports.default;